export const PROFILES_RECIEVED = "PROFILES_RECIEVED";
export const PROFILE_CREATED = "PROFILE_CREATED";
export const PROFILE_UPDATED = "PROFILE_UPDATED";
export const PROFILE_DELETED = "PROFILE_DELETED";
export const PROFILES_DELETED = "PROFILES_DELETED";
